import type { RouteConfig } from 'vue-router'

import { ensureToken } from '@/router/guards/ensureToken'

export default [
  {
    path: '/funding',
    name: 'funding',
    meta: {
      isResourcesEnabled: true
    },
    component: () => import(/* webpackChunkName: "resources-views" */ './views/Funding.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/find-a-Bookkeeper',
    name: 'bookkeeper',
    meta: {
      isResourcesEnabled: true
    },
    component: () => import(/* webpackChunkName: "resources-views" */ './views/FindBookkeeper.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/list-my-business',
    name: 'listMyBusiness',
    meta: {
      isResourcesEnabled: true
    },
    component: () => import(/* webpackChunkName: "resources-views" */ './views/ListMyBusiness.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/fr8-competition',
    name: 'fr8Competition',
    meta: {
      isResourcesEnabled: true
    },
    component: () => import(/* webpackChunkName: "resources-views" */ './views/Fr8Competition.vue'),
    beforeEnter: ensureToken
  }
] as Array<RouteConfig>
